<template>
  <LoginSingleLayout wide>
    <Alert :i18nData="asyncError" />
    <div class="recover-pass">
      <p class="title-xs bold recover-pass__title">
        {{ $t('pages.recoverPass.title') }}
      </p>

      <b-form class="recover-pass__form" @submit.prevent="onSubmit">
        <div class="nl-field">
          <label class="nl-field__label" for="recover-password">
            {{ $t('pages.recoverPass.passwordLabel') }}
          </label>
          <div class="nl-input nl-input--password">
            <input
              id="recover-password"
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              autocomplete="off"
              class="nl-input__control"
              required
            >
            <button
              type="button"
              class="nl-eye"
              :aria-label="$t('pages.recoverPass.passwordLabel')"
              @click="showPassword = !showPassword"
            >
              <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
            </button>
          </div>
          <p class="body-xs recover-pass__hint" v-html="$t('pages.recoverPass.passwordDescription')" />
        </div>

        <div class="recover-pass__actions">
          <button
            type="submit"
            class="nl-submit nl-submit--brand"
            :disabled="form.password.length < 8 || loading"
          >
            {{ $t('pages.recoverPass.buttonOk') }}
          </button>
        </div>
      </b-form>
    </div>
  </LoginSingleLayout>
</template>

<script>
import { mapActions } from 'vuex'
import { E_SERVER_HTTP } from '@/constants'
import LoginSingleLayout from '@/components/LoginSingleLayout.vue'
import { turnOffZoom } from '@/utils'
import { getFingerprintData } from '@/utils/fingerprint'

export default {
  name: 'RecoverPassword',
  components: {
    LoginSingleLayout
  },
  data () {
    return {
      form: {
        password: ''
      },
      loading: false,
      asyncError: null,
      showPassword: false
    }
  },
  watch: {
    form: { // clean async error on new input
      handler () { this.asyncError = null },
      deep: true
    }
  },
  methods: {
    ...mapActions(['validationAction', 'cleanRecover']),
    async onSubmit () {
      this.loading = true
      this.asyncError = null
      const fingerprint = await getFingerprintData()
      return this.validationAction({ password: this.form.password, fingerprint }).then((res) => {
        if (res.result !== 'PASSWORD UPDATED') {
          throw new Error(`Unexpected response on password update: ${res.result}`)
        }
        this.$router.push({ name: 'login' })
        this.$toasted.success(this.$t('pages.recoverPass.success'))
        return this.cleanRecover()
      }).catch(err => {
        if (err.id === E_SERVER_HTTP && err.code === 400) {
          this.asyncError = { key: 'pages.recoverPass.error' }
        } else {
          throw err
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    turnOffZoom()
  }
}
</script>

<style lang="scss" scoped>
.recover-pass {
  width: 100%;

  &__title {
    margin-bottom: $spacer*1.5;
    text-align: center;
  }

  &__form {
    width: 100%;
  }

  &__hint {
    margin: $spacer*0.75 0 0;
    color: $nl-text-muted;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: $spacer*2.5;
  }
}
</style>
